import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { AVAILABLE_DATES_KEY } from '../constants';
import { fetchAvailableDates } from '@modules/genetic-counseling/services';
import { AvailableDatesResponse, UseQueryAvailableDatesParams } from '../types';
import { useAuth } from '@/modules/auth/hooks';

const useQueryAvailableDates = <TError = unknown>(
  params: UseQueryAvailableDatesParams,
  options?: Omit<
    UseQueryOptions<
      AvailableDatesResponse | undefined,
      TError,
      AvailableDatesResponse | undefined,
      Array<string | UseQueryAvailableDatesParams>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<AvailableDatesResponse | undefined> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;

  return useQuery([AVAILABLE_DATES_KEY, params], async () => await fetchAvailableDates(params), {
    ...options,
    enabled: isAuthenticated === true && enabledOption,
  });
};

export default useQueryAvailableDates;
